"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Object = _interopRequireDefault(require("./Object.js"));

var _MapEventType = _interopRequireDefault(require("./MapEventType.js"));

var _OverlayPositioning = _interopRequireDefault(require("./OverlayPositioning.js"));

var _css = require("./css.js");

var _extent = require("./extent.js");

var _events = require("./events.js");

var _dom = require("./dom.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Overlay
 */


/**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {import("./OverlayPositioning.js").default} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport?
 * If `true` (deprecated), then `autoPanAnimation` and `autoPanMargin` will be
 * used to determine the panning parameters; if an object is supplied then other
 * parameters are ignored.
 * @property {PanOptions} [autoPanAnimation] The animation options used to pan
 * the overlay into view. This animation is only used when `autoPan` is enabled.
 * A `duration` and `easing` may be provided to customize the animation.
 * Deprecated and ignored if `autoPan` is supplied as an object.
 * @property {number} [autoPanMargin=20] The margin (in pixels) between the
 * overlay and the borders of the map when autopanning. Deprecated and ignored
 * if `autoPan` is supplied as an object.
 * @property {PanIntoViewOptions} [autoPanOptions] The options to use for the
 * autoPan. This is only used when `autoPan` is enabled and has preference over
 * the individual `autoPanMargin` and `autoPanOptions`.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */

/**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */

/**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */

/**
 * @enum {string}
 * @protected
 */
var Property = {
  ELEMENT: 'element',
  MAP: 'map',
  OFFSET: 'offset',
  POSITION: 'position',
  POSITIONING: 'positioning'
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */

/**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay';
 *
 *     var popup = new Overlay({
 *       element: document.getElementById('popup')
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */

var Overlay =
/** @class */
function (_super) {
  __extends(Overlay, _super);
  /**
   * @param {Options} options Overlay options.
   */


  function Overlay(options) {
    var _this = _super.call(this) || this;
    /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */


    _this.on;
    /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */

    _this.once;
    /***
     * @type {OverlayOnSignature<void>}
     */

    _this.un;
    /**
     * @protected
     * @type {Options}
     */

    _this.options = options;
    /**
     * @protected
     * @type {number|string|undefined}
     */

    _this.id = options.id;
    /**
     * @protected
     * @type {boolean}
     */

    _this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
    /**
     * @protected
     * @type {boolean}
     */

    _this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
    /**
     * @protected
     * @type {HTMLElement}
     */

    _this.element = document.createElement('div');
    _this.element.className = options.className !== undefined ? options.className : 'ol-overlay-container ' + _css.CLASS_SELECTABLE;
    _this.element.style.position = 'absolute';
    _this.element.style.pointerEvents = 'auto';
    var autoPan = options.autoPan;

    if (autoPan && 'object' !== _typeof(autoPan)) {
      autoPan = {
        animation: options.autoPanAnimation,
        margin: options.autoPanMargin
      };
    }
    /**
     * @protected
     * @type {PanIntoViewOptions|false}
     */


    _this.autoPan =
    /** @type {PanIntoViewOptions} */
    autoPan || false;
    /**
     * @protected
     * @type {{transform_: string,
     *         visible: boolean}}
     */

    _this.rendered = {
      transform_: '',
      visible: true
    };
    /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */

    _this.mapPostrenderListenerKey = null;

    _this.addChangeListener(Property.ELEMENT, _this.handleElementChanged);

    _this.addChangeListener(Property.MAP, _this.handleMapChanged);

    _this.addChangeListener(Property.OFFSET, _this.handleOffsetChanged);

    _this.addChangeListener(Property.POSITION, _this.handlePositionChanged);

    _this.addChangeListener(Property.POSITIONING, _this.handlePositioningChanged);

    if (options.element !== undefined) {
      _this.setElement(options.element);
    }

    _this.setOffset(options.offset !== undefined ? options.offset : [0, 0]);

    _this.setPositioning(options.positioning !== undefined ?
    /** @type {import("./OverlayPositioning.js").default} */
    options.positioning : _OverlayPositioning["default"].TOP_LEFT);

    if (options.position !== undefined) {
      _this.setPosition(options.position);
    }

    return _this;
  }
  /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */


  Overlay.prototype.getElement = function () {
    return (
      /** @type {HTMLElement|undefined} */
      this.get(Property.ELEMENT)
    );
  };
  /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */


  Overlay.prototype.getId = function () {
    return this.id;
  };
  /**
   * Get the map associated with this overlay.
   * @return {import("./PluggableMap.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */


  Overlay.prototype.getMap = function () {
    return (
      /** @type {import("./PluggableMap.js").default|null} */
      this.get(Property.MAP) || null
    );
  };
  /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */


  Overlay.prototype.getOffset = function () {
    return (
      /** @type {Array<number>} */
      this.get(Property.OFFSET)
    );
  };
  /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */


  Overlay.prototype.getPosition = function () {
    return (
      /** @type {import("./coordinate.js").Coordinate|undefined} */
      this.get(Property.POSITION)
    );
  };
  /**
   * Get the current positioning of this overlay.
   * @return {import("./OverlayPositioning.js").default} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */


  Overlay.prototype.getPositioning = function () {
    return (
      /** @type {import("./OverlayPositioning.js").default} */
      this.get(Property.POSITIONING)
    );
  };
  /**
   * @protected
   */


  Overlay.prototype.handleElementChanged = function () {
    (0, _dom.removeChildren)(this.element);
    var element = this.getElement();

    if (element) {
      this.element.appendChild(element);
    }
  };
  /**
   * @protected
   */


  Overlay.prototype.handleMapChanged = function () {
    if (this.mapPostrenderListenerKey) {
      (0, _dom.removeNode)(this.element);
      (0, _events.unlistenByKey)(this.mapPostrenderListenerKey);
      this.mapPostrenderListenerKey = null;
    }

    var map = this.getMap();

    if (map) {
      this.mapPostrenderListenerKey = (0, _events.listen)(map, _MapEventType["default"].POSTRENDER, this.render, this);
      this.updatePixelPosition();
      var container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();

      if (this.insertFirst) {
        container.insertBefore(this.element, container.childNodes[0] || null);
      } else {
        container.appendChild(this.element);
      }

      this.performAutoPan();
    }
  };
  /**
   * @protected
   */


  Overlay.prototype.render = function () {
    this.updatePixelPosition();
  };
  /**
   * @protected
   */


  Overlay.prototype.handleOffsetChanged = function () {
    this.updatePixelPosition();
  };
  /**
   * @protected
   */


  Overlay.prototype.handlePositionChanged = function () {
    this.updatePixelPosition();
    this.performAutoPan();
  };
  /**
   * @protected
   */


  Overlay.prototype.handlePositioningChanged = function () {
    this.updatePixelPosition();
  };
  /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */


  Overlay.prototype.setElement = function (element) {
    this.set(Property.ELEMENT, element);
  };
  /**
   * Set the map to be associated with this overlay.
   * @param {import("./PluggableMap.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */


  Overlay.prototype.setMap = function (map) {
    this.set(Property.MAP, map);
  };
  /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */


  Overlay.prototype.setOffset = function (offset) {
    this.set(Property.OFFSET, offset);
  };
  /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */


  Overlay.prototype.setPosition = function (position) {
    this.set(Property.POSITION, position);
  };
  /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */


  Overlay.prototype.performAutoPan = function () {
    if (this.autoPan) {
      this.panIntoView(this.autoPan);
    }
  };
  /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [opt_panIntoViewOptions] Options for the pan action
   * @api
   */


  Overlay.prototype.panIntoView = function (opt_panIntoViewOptions) {
    var map = this.getMap();

    if (!map || !map.getTargetElement() || !this.get(Property.POSITION)) {
      return;
    }

    var mapRect = this.getRect(map.getTargetElement(), map.getSize());
    var element = this.getElement();
    var overlayRect = this.getRect(element, [(0, _dom.outerWidth)(element), (0, _dom.outerHeight)(element)]);
    var panIntoViewOptions = opt_panIntoViewOptions || {};
    var myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;

    if (!(0, _extent.containsExtent)(mapRect, overlayRect)) {
      // the overlay is not completely inside the viewport, so pan the map
      var offsetLeft = overlayRect[0] - mapRect[0];
      var offsetRight = mapRect[2] - overlayRect[2];
      var offsetTop = overlayRect[1] - mapRect[1];
      var offsetBottom = mapRect[3] - overlayRect[3];
      var delta = [0, 0];

      if (offsetLeft < 0) {
        // move map to the left
        delta[0] = offsetLeft - myMargin;
      } else if (offsetRight < 0) {
        // move map to the right
        delta[0] = Math.abs(offsetRight) + myMargin;
      }

      if (offsetTop < 0) {
        // move map up
        delta[1] = offsetTop - myMargin;
      } else if (offsetBottom < 0) {
        // move map down
        delta[1] = Math.abs(offsetBottom) + myMargin;
      }

      if (delta[0] !== 0 || delta[1] !== 0) {
        var center =
        /** @type {import("./coordinate.js").Coordinate} */
        map.getView().getCenterInternal();
        var centerPx = map.getPixelFromCoordinateInternal(center);

        if (!centerPx) {
          return;
        }

        var newCenterPx = [centerPx[0] + delta[0], centerPx[1] + delta[1]];
        var panOptions = panIntoViewOptions.animation || {};
        map.getView().animateInternal({
          center: map.getCoordinateFromPixelInternal(newCenterPx),
          duration: panOptions.duration,
          easing: panOptions.easing
        });
      }
    }
  };
  /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */


  Overlay.prototype.getRect = function (element, size) {
    var box = element.getBoundingClientRect();
    var offsetX = box.left + window.pageXOffset;
    var offsetY = box.top + window.pageYOffset;
    return [offsetX, offsetY, offsetX + size[0], offsetY + size[1]];
  };
  /**
   * Set the positioning for this overlay.
   * @param {import("./OverlayPositioning.js").default} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */


  Overlay.prototype.setPositioning = function (positioning) {
    this.set(Property.POSITIONING, positioning);
  };
  /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */


  Overlay.prototype.setVisible = function (visible) {
    if (this.rendered.visible !== visible) {
      this.element.style.display = visible ? '' : 'none';
      this.rendered.visible = visible;
    }
  };
  /**
   * Update pixel position.
   * @protected
   */


  Overlay.prototype.updatePixelPosition = function () {
    var map = this.getMap();
    var position = this.getPosition();

    if (!map || !map.isRendered() || !position) {
      this.setVisible(false);
      return;
    }

    var pixel = map.getPixelFromCoordinate(position);
    var mapSize = map.getSize();
    this.updateRenderedPosition(pixel, mapSize);
  };
  /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */


  Overlay.prototype.updateRenderedPosition = function (pixel, mapSize) {
    var style = this.element.style;
    var offset = this.getOffset();
    var positioning = this.getPositioning();
    this.setVisible(true);
    var x = Math.round(pixel[0] + offset[0]) + 'px';
    var y = Math.round(pixel[1] + offset[1]) + 'px';
    var posX = '0%';
    var posY = '0%';

    if (positioning == _OverlayPositioning["default"].BOTTOM_RIGHT || positioning == _OverlayPositioning["default"].CENTER_RIGHT || positioning == _OverlayPositioning["default"].TOP_RIGHT) {
      posX = '-100%';
    } else if (positioning == _OverlayPositioning["default"].BOTTOM_CENTER || positioning == _OverlayPositioning["default"].CENTER_CENTER || positioning == _OverlayPositioning["default"].TOP_CENTER) {
      posX = '-50%';
    }

    if (positioning == _OverlayPositioning["default"].BOTTOM_LEFT || positioning == _OverlayPositioning["default"].BOTTOM_CENTER || positioning == _OverlayPositioning["default"].BOTTOM_RIGHT) {
      posY = '-100%';
    } else if (positioning == _OverlayPositioning["default"].CENTER_LEFT || positioning == _OverlayPositioning["default"].CENTER_CENTER || positioning == _OverlayPositioning["default"].CENTER_RIGHT) {
      posY = '-50%';
    }

    var transform = "translate(".concat(posX, ", ").concat(posY, ") translate(").concat(x, ", ").concat(y, ")");

    if (this.rendered.transform_ != transform) {
      this.rendered.transform_ = transform;
      style.transform = transform; // @ts-ignore IE9

      style.msTransform = transform;
    }
  };
  /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */


  Overlay.prototype.getOptions = function () {
    return this.options;
  };

  return Overlay;
}(_Object["default"]);

var _default = Overlay;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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